var Progression = {

    init: function() {
        Progression.bindFlightPathEditor();
        Progression.bindProgressionSelects();
        Progression.bindProgressionSmartFill();
        Progression.bindProgressionSave();
        Progression.bindRecalculate();
        Progression.bindClearTargets();
        Progression.bindYearlyTargetSelect();
        //Progression.bindPredictionComment();
        Progression.bindYearSelect();
        Progression.bindPredictiveTargets();
    },

    // bindPredictionComment: function() {
    //     $('.prediction-comment-input').keyup(function() {
    //         var input = $(this);
    //     });
    // },

    bindPredictiveTargets: function(){
        $('.predictive-targets').on('click', function() {
            var url = window.location.href;
            var predictiveFalse = (url.indexOf('predictive_targets=false') > -1);
            var predictiveTrue = (url.indexOf('predictive_targets=true') > -1);
            // toggle predictive targets
            if (predictiveFalse) {
                url = url.replace('predictive_targets=false', 'predictive_targets=true');
            } else if (predictiveTrue){
                url = url.replace('predictive_targets=true', 'predictive_targets=false');
            } else {
                var hasQuery = (url.indexOf('?') > -1);
                if (!hasQuery) {
                    url += '?predictive_targets=true';
                } else {
                    url += '&predictive_targets=true';
                }
            }
            url = Progression.putYearInUrl(url);
            window.location.href = url;
        });
    },

    bindYearSelect: function() {
        $('#yearSelect').change(function() {
            var url = window.location.href;
            /*
            var input = $(this);
            var year = input.val();
            var url = window.location.href;
            var yearPos = url.indexOf('year=');
            if (yearPos == -1) {
                // yet to add year=CCYY-CCYY to query
                var hasQuery = (url.indexOf('?') > -1);
                if (!hasQuery) {
                    // yet to add a query
                    url = url + '?year=' + year;
                } else {
                    // query already added
                    url = url + '&year=' + year;
                }
            } else {
                // already added year=CCYY-CCYY to query
                url = url.substr(0, yearPos) + 'year=' + year + url.substr(yearPos + 14);
            }
            */
            url = Progression.putYearInUrl(url);
            window.location.href = url;
        })
    },

    putYearInUrl: function(url) {
        var year = $('#yearSelect').val();
        var yearPos = url.indexOf('year=');
        if (yearPos == -1) {
            // yet to add year=CCYY-CCYY to query
            var hasQuery = (url.indexOf('?') > -1);
            if (!hasQuery) {
                // yet to add a query
                url = url + '?year=' + year;
            } else {
                // query already added
                url = url + '&year=' + year;
            }
        } else {
            // already added year=CCYY-CCYY to query
            url = url.substr(0, yearPos) + 'year=' + year + url.substr(yearPos + 14);
        }

        return(url);
    },

    bindYearlyTargetSelect: function(){
        $('.yearly-target').change(function(e) {
            var select = $(this);
            var pupilId = select.data('pupil');
            var subjectId = select.data('subject');
            var option = select.find('option:selected').clone();
            var value = select.val();
            if (select.hasClass('end-prediction')) {
                var count = select.data('count');
                var other = $('#term-' + count + '-' + pupilId + '-' + subjectId);
            } else {
                var other = $('#end-' + pupilId + '-' + subjectId);
            }
            other.append(option);
            other.val(value);
        });
    },

    bindClearTargets: function() {
        $('.clear-targets').click(function() {
            var button = $(this);
            var pupilId = button.data('pupil');
            var subjectId = button.data('subject');
            $.get('/predictions/' + pupilId + '/' + subjectId + '/clear', function(res) {
                if (!res['success']) {
                    alert('Action failed. Please try again.');
                    return false;
                }
                var targetSelects = $('.target-' + pupilId + '-' + subjectId);
                targetSelects.empty();
                alert('Targets have been cleared successfully!');
            });
        });
    },

    /**
     * Bind flight path editor
     */
    bindFlightPathEditor: function() {
        $('#flightpath-subject-select').change(function(e) {
            var url = '/admin/frameworks/' + $(this).data('framework') + '/flight-paths/' + $(this).val() + '/' + $('#flightpath-key-stage').val();
            $.get(url, function(data) {
                $('#flightpath-editor').html(data);
                $('#flight-path-add').attr('data-route', url + '/add');
                App.initSelect2();
                Admin.bindCreateTermlyTargets();
            });
        });

        $('#flightpath-key-stage').change(function(e) {
            var subjectId = $('#flightpath-subject-select').val();
            if (!subjectId) {
                return false;
            }
            var url = '/admin/frameworks/' + $(this).data('framework') + '/flight-paths/' + subjectId + '/' + $(this).val();
            $.get(url, function(data) {
                $('#flightpath-editor').html(data);
                $('#flight-path-add').attr('data-route', url + '/add');
                App.initSelect2();
                Admin.bindCreateTermlyTargets();
            });
        });
    },

    bindRecalculate: function() {
        $('.recalculate-level-steps').click(function(e) {
            $('#recalculateProgress').show();
            var url = $(this).data('href');
            e.preventDefault();
            $.get(url, function(res) {
                if (res['success']) {
                    $('#recalculateProgress').html('Complete. Refreshing page.');
                    window.location.reload();
                }
            });
        });
    },

    /**
     * Bind progression selects
     *
     *
     */
    bindProgressionSelects: function() {
        $('#progression-assessment-framework').on('change', function() {
            window.location.href = '/progression/frameworks/' + $(this).val();
        });

        $('#progression-subject').on('change', function() {
            window.location.href = '/progression/frameworks/' + $('#progression-assessment-framework').val() + '/' + $(this).val();
        });

        $('.progression-pupil-term').select2({
          ajax: {
            url: function (args) {
                return '/progression/level-steps/' + $(this.context).data('pupil') + '/' + $(this.context).data('subject');
            },
            placeholder: 'Find Level',
            dataType: 'json',
            delay: 0,
            data: function (params) {
              return {
                q: params.term,
                page: params.page
              };
            },
            results: function (data, page) {
                return { results: data.results };
            },
          },
          minimumInputLength: 1
        });

        $('.progression-pupil-key-stage').select2({
          ajax: {
            url: function (args) {
                return '/progression/level-steps/' + $(this.context).data('pupil') + '/' + $(this.context).data('subject');
            },
            placeholder: 'Find Key Stage',
            dataType: 'json',
            delay: 0,
            data: function (params) {
              return {
                q: params.term,
                page: params.page
              };
            },
            results: function (data, page) {
                return { results: data.results };
            },
          },
          minimumInputLength: 1
        });
    },

    /**
     *
     *
     *
     */
    bindProgressionSave: function() {
        $('.btn-save').click(function(e) {
            e.preventDefault();

            var frameworkId = $(this).data('framework-id');
            //var classId = $(this).data('class-id');
            var subjectId = $(this).data('subject-id');
            var pupilId = $(this).data('pupil-id');
            var url = null;

            if (subjectId) {
                url = '/progression/frameworks?frameworkId=' + frameworkId + '&subjectId=' + subjectId;
            } else {
                url = '/progression/frameworks?frameworkId=' + frameworkId + '&pupilId=' + pupilId;
            }
            var datastring = $("#progression-form").serialize();

            $('.progression-error').hide();
            $('.progression-success').hide();

            $.ajax({
                type: "POST",
                url: url,
                data: datastring,
                dataType: "json",
                success: function(data) {
                    // alert('Prediction successful');
                    $('.progression-success').show();
                },
                error: function(data) {
                    // alert('Prediction Error');
                    $('.progression-error').show();
                }
            });
        })
    },

    /**
     * Fill in level select boxes for student(s) based on their current performance and the key stage target set by the user
     *
     *
     */
    bindProgressionSmartFill: function() {
        $('.smart-fill').click(function() {
            //Initialising variables
            var fillButton = $(this);
            var pupilId = fillButton.data('pupil');
            var subjectId = fillButton.data('subject');

            var yearStartLevelId = fillButton.data('year_start_level');
            var yearStartPercentage = fillButton.data('year_start_percentage');

            //var target = $('.level-' + subjectId).val();
            //var filterId = subjectId;
            // if (fillButton.data('yearly') === 'false') {
            //     target = $('.keystage-' + subjectId).val();
            // }

            var target = $('.keystage-' + fillButton.data('subject')).val();
            var filterId = subjectId;

            if (fillButton.hasClass('pupil-fill')) {
                target = $('.keystage-' + pupilId).val();
                filterId = pupilId;
            }

            var start = 0;
            var startEl = $('#start-' + filterId);
            if (startEl.length > 0) {
                start = startEl.val();
            }
            if (!target) {
                return alert('Please select a Key Stage or Yearly target before smart filling.');
            }
            var academicYear = $('#yearSelect').children('option:selected').val();

            var data = {
                pupil_id: pupilId,
                subject_id: subjectId,
                key_stage_target: target,
                start: start,
                academicYear: academicYear,
                year_start_level_id: yearStartLevelId,
                year_start_percentage: yearStartPercentage,
            };
            /* this just counts the length of the string: '.term-heading-' + filterId ???
            var termsDisplayed = ('.term-heading-' + filterId).length;
            */
            var termsDisplayed = $('.term-heading-' + filterId).length;
            //var termsDisplayed = 6;
            $.post('/progression/predict', data, function(response) {
                console.log(response);
                if (!response.success) {
                    $('.level-' + filterId).find('option').remove();
                    if (response.message !== undefined) {
                        return alert(response.message);
                    } else {
                        return alert('Server error');
                    }
                }
                var currentInput;
                var max;
                var min = 0;
                if (start != 0) {
                    max = start;
                    min = start - 1;
                    for (var x = 0; x < max; x++) {
                        currentInput = '.level-' + filterId + ':eq(' + x + ')';
                        $(currentInput).find('option').remove();
                    }
                }
                termsDisplayed = $('.level-' + filterId).length;
                var termsCount = response.termImprovements.length;
                for (var z = min; z < termsDisplayed; z++) {
                    if (z >= termsCount) {
                        break;
                    }
                    currentInput = $('.level-' + filterId + ':eq(' + z + ')');
                    var termData = response.termImprovements.shift();
                    var valueToSelect = termData.value;
                    var textToSelect = termData.text;
                    if (currentInput.is('select')) {
                        currentInput.append('<option value="' + valueToSelect + '">' + textToSelect + '</option>');
                        currentInput.val(valueToSelect).trigger('change');
                    } else {
                        currentInput.val(termData.value);
                    }
                }
            });
        });
    }
};